import * as React from "react";
import Timestamp from "./Timestamp";
import { FunctionalIFrameComponent } from "./FunctionalIFrameComponent";
import { TogglesClass } from "./Toggles";

interface TLEMRProps {
  Toggles: TogglesClass;
  Object: any;
  Squished: boolean;
  ID: number;
  SquishMe: (ident: number) => void;
}

export default function TLEntryMailRequest(props: TLEMRProps) {
  if (props.Object["Subtype"] === "Queued") {
    return <></>;
  } else {
    return (
      <div className="MailRequestEntry">
        <div className="Icon">&#128269;</div>
        <div className="Label">Email</div>
        <Timestamp
          Timestamp={props.Object["Timestamp"]}
          Toggles={props.Toggles}
        />
        Email
        {props.Object["Subtype"] === "Queued" ? (
          " queued..."
        ) : (
          <React.Fragment>
            {" "}
            sent! <b>{props.Object["Subject"]}</b>{" "}
            <button
              className={
                "SquishButton" + (props.Squished === false ? "" : " Squished")
              }
              onClick={() => props.SquishMe(props.Object)}
            >
              {props.Squished === false ? (
                <React.Fragment>&#8722;</React.Fragment>
              ) : (
                <React.Fragment>&#43;</React.Fragment>
              )}
            </button>
            {props.Squished === undefined || props.Squished === true ? (
              ""
            ) : (
              <table>
                <tbody>
                  <tr>
                    <th>Recipients</th>
                    <td>{props.Object["Recipients"]}</td>
                  </tr>
                  {props.Object["CCs"] !== "" ? (
                    <tr>
                      <th>CCs</th>
                      <td>{props.Object["CCs"]}</td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {props.Object["CCs"] !== "" ? (
                    <tr>
                      <th>BCCs</th>
                      <td>{props.Object["BCCs"]}</td>
                    </tr>
                  ) : (
                    ""
                  )}
                  <tr>
                    <th>From</th>
                    <td>{props.Object["FromAddress"]}</td>
                  </tr>
                  {props.Object["ReplyTo"] !== props.Object["FromAddress"] ? (
                    <tr>
                      <th>Reply</th>
                      <td>{props.Object["ReplyTo"]}</td>
                    </tr>
                  ) : (
                    ""
                  )}
                  <tr>
                    <th>Subject</th>
                    <td>
                      <b>{props.Object["Subject"]}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      {props.Object["BodyFormat"] === "HTML" ? (
                        <FunctionalIFrameComponent
                          className="EmailRenderPane"
                          title="functional-iframe"
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: props.Object["Body"],
                            }}
                          />
                        </FunctionalIFrameComponent>
                      ) : (
                        <textarea
                          className="EmailRenderPane"
                          value={props.Object["Body"]}
                          readOnly={true}
                        ></textarea>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}
